import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity';
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem';
export class OficialDeMesaOfflineAssertions extends AssertionEntity {
  private constructor() {
    super();
  }

  static build() {
    const instance = new this();
    instance.addAssertionForName()
    instance.addAssertionForLastName()
    instance.addAssertionForDocumentNum()
    return instance;
  }

  addAssertionForName(key = 'odmo_nombre') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Nombre es obligatorio'
      )
    );
  }

  addAssertionForLastName(key = 'odmo_apellido') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Apellido es obligatorio'
      )
    );
  }

  addAssertionForDocumentNum(key = 'odmo_nro_doc') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Número de Documento es obligatorio'
      )
    );
  }
}
